// import { Helmet } from "react-helmet-async";
import TechGrid from '../components/TechGrid';
import ProjectGrid from '../components/ProjectGrid';

function Home() {
  /* const schemaData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Uyonoh",
      alternateName: ["Uyonoh Portfolio", "Uyonoh's Portfolio"],
      url: "https://uyonoh.com/",
    },
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Uyonoh",
      url: "https://uyonoh.com/",
      jobTitle: "Full-Stack Web Developer, Python Engineer & GIS Analyst",
      description:
        "A passionate Full-Stack Web Developer, Python Engineer, and GIS Analyst...",
      sameAs: [
        "https://github.com/uyonoh",
        "https://x.com/uyonoh",
        "https://www.linkedin.com/in/uyonoh",
        "https://www.facebook.com/uyonoh.turaki/",
      ],
    },
  ]; */

  return (
    <>
      {/* <!-- Home Section --> */}
      <section id="home" className="hero">
        <div className="profile">
          <img
            id="profile-pic"
            src="/assets/images/profile/profile.jpg"
            alt="Uyonoh Turaki"
            width="250"
            height="250"
            loading="eager"
            style={{ borderRadius: '50%', objectFit: 'cover' }}
          />
        </div>
        <h1 className="w-full max-w-xl sm:max-w-[30vw] break-words text-3xl sm:text-4xl font-bold">
          {' '}
          <span className="d-block brand-name">Uyonoh Turaki</span>
          <span className="sub-heading">Full-Stack Web developer, Python Engineer &amp; GIS Analyst</span>
        </h1>
        <p className="blue-green text-center">
          Building the future with code and innovation.
        </p>
        <button onClick={() => (window.location.href = '#projects')}>
          My Work
        </button>
        <button
          className="button outline"
          onClick={() => (window.location.href = '#footer')}
        >
          Get in Touch
        </button>
      </section>

      {/* Tech stack section */}
      <section id="tech-stack" className="py-5 ">
        <div className="container text-center">
          <h2
            className="mb-4 blue-green"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            Power Tools
          </h2>

          <TechGrid />
        </div>
      </section>

      {/* <!-- Projects Section --> */}
      <section
        id="projects"
        className="container pt-5 mt-5"
        data-aos="fade-right"
        data-aos-offset="10"
        data-aos-delay="200"
        data-aos-duration="1000"
      >
        <h2 className="blue-green">Projects</h2>
        <ProjectGrid />
      </section>

      {/* <!-- About Section -->
      <section
        id="about"
        className="container pt-5 mt-5"
        data-aos="zoom-in-up"
        data-aos-offset="10"
        data-aos-delay="200"
        data-aos-duration="1000"
      >
        <h2 className="blue-green">About Me</h2>
        <p>
          I am a passionate web developer, python engineer and GIS analyst with
          a passion for building intelligent, data-driven applications.
        </p>
        <h3>My journey</h3>
        <p>
          While taking my first degree in Surveying and Geo-informatics, I honed
          my skills in spatial data analysis and visualization. Immersed in my
          love for programming, I expanded my expertise to Python programming,
          machine learning and web development, allowing me to bridge the gap
          between geospatial data and AI powered solutions. I eventually got
          into the C programming language to further my understanding of
          programming and computer fundamentals and memory management.
        </p>
        <p>
          Throughout my journey, I have worked on projects ranging from building
          footprint extraction using Mask-RCNN to developing automated data
          pipelines and deploying full-stack web applications.
        </p>
        <p>
          I now have experience with technologies like Django, React,
          PostgreSQL, Tensorflow, and cloud deployment platforms. Whether it's
          optimizing geospatial workflows, creating dynamic web applications, or
          training AI models, I thrive on solving complex problems and building
          scalable, impactful solutions.
        </p>
      </section> */}
    </>
  );
}

export default Home;
